import { getSuggestions, getPlaceDetails } from 'api/location';
import {
  call,
  delay,
  Effect,
  put,
  select,
  SelectEffect,
} from 'redux-saga/effects';
import actions, {
  AutocompleteActionType,
} from 'redux/actions/autocompleteActions';
import { updateTemporalLocation } from 'redux/actions/locationActions';
import {
  currentLanguageSelector,
  mapAutocompleteCountriesToSearchSelector,
} from 'redux/selectors/config';
import { parseCountryCodes } from 'utils/map-utils';

export function* getAutocompleteOptionsWithGoogle(
  action: AutocompleteActionType,
): Generator<Effect | SelectEffect, void, any> {
  try {
    yield put(actions.autocompleteSearchStart());

    if (!action.payload) {
      return yield put(actions.autocompleteSearchFail());
    }

    const language: string = yield select(currentLanguageSelector);
    const countryCodes: string[] | undefined = yield select(
      mapAutocompleteCountriesToSearchSelector,
    );

    if (!countryCodes) {
      throw new Error('No country code set, check Prismic configuration');
    }

    const components = parseCountryCodes(countryCodes);

    yield delay(300);
    const response = yield call(getSuggestions, {
      input: action.payload,
      language,
      components,
    });
    if (response.ok && response.result?.length > 0) {
      yield put(actions.autocompleteSearchSuccess(response.result as any[]));
    } else {
      throw new Error(response);
    }
  } catch (error) {
    console.log({ error });
    yield put(actions.autocompleteSearchFail());
  }
}

export function* getPlaceDetailsFromGoogleByPlaceId(
  action: AutocompleteActionType,
): Generator<Effect | SelectEffect, void, any> {
  try {
    const placeId = action.payload;

    if (!placeId) {
      throw new Error('placeId is missing in payload');
    }

    const language: string = yield select(currentLanguageSelector);
    const response = yield call(getPlaceDetails, {
      language,
      placeId,
    });

    if (response.ok) {
      yield put(
        updateTemporalLocation({
          address: response.result.address,
          coordinates: response.result.location,
        }),
      );
    } else {
      throw new Error(response);
    }
  } catch (error) {
    console.log(
      'Error while getting details from place id (google maps)',
      error,
    );
  }
}
